export default __webpack_public_path__ + "static/media/26910830_241433526396434_727528337417599327_o.5dd15423.png";